const modulesBase = {
  NAVEGACAO_LIVRE_DISCIPLINAS: {
    ID: 'universitario-navegacao-livre',  //Alterar para o módulo criado - OK
  },
};

const PlatformModules: Record<string, { ID: string }> = {
  ...modulesBase,
};

export default PlatformModules;
